export const Props = () => ({
  //ID подкаста, к которому относится этот прогресс бар
  idPodcast: {
    type: Number,
    required: true,
  },
});